// extracted by mini-css-extract-plugin
export default {"textBlockOne":"confirm-change-super-speed-prod-time-popup__textBlockOne___iliu8"};